import { PayloadAction } from '@reduxjs/toolkit';
import { ProductState } from 'store/product/types';

const setPersonalisedProductDataReducer = (
  state: ProductState,
  action: PayloadAction<{
    productUid?: string;
    productName?: string;
  }>,
) => {
  state.productUid = action.payload.productUid;
  state.productName = action.payload.productName;
};

export default setPersonalisedProductDataReducer;
